import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

import { AppConfig } from '../models/app-config.model';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private readonly configUrl = 'assets/' + environment.config;
  private config?: AppConfig;
  private config$?: Observable<AppConfig>;

  constructor(private http: HttpClient) {}

  loadConfig(): Observable<AppConfig> {
    if (!this.config$) {
      this.config$ = this.http.get<AppConfig>(this.configUrl).pipe(
        tap((config) => (this.config = config)),
        shareReplay(1)
      );
    }

    return this.config$;
  }

  getMainEndpoint(): string {
    return this.config?.mainEndpoint || '';
  }

  getAuthenticationEndpoint(): string {
    return this.config?.authenticationEndpoint || '';
  }
}
